<p-dropdown [options]="list" [(ngModel)]="selectedItem" optionLabel="label" [filter]="true" filterBy="label" [showClear]="true" [placeholder]="placeHolderLanguage" (onChange)="feedback()">
